module.exports = __webpack_public_path__ + "img/pr-20.9eb49cf8.png";